import AutoFormLabel from "../common/label";
import AutoFormTooltip from "../common/tooltip";
import { AutoFormInputComponentProps } from "../types";
import { FormControl, FormItem, FormMessage } from "@/components/ui/form";

import { DateTimePicker } from "@/components/fields/date-time-picker";

export default function AutoFormDateTime({
  label,
  isRequired,
  field,
  fieldConfigItem,
  fieldProps,
}: AutoFormInputComponentProps) {
  const { showLabel: _showLabel, ...fieldPropsWithoutShowLabel } = fieldProps;
  const showLabel = _showLabel === undefined ? true : _showLabel;

  return (
    <FormItem className="flex flex-col text-foreground">
      {showLabel && (
        <AutoFormLabel
          label={fieldConfigItem?.label || label}
          isRequired={fieldPropsWithoutShowLabel.required}
        />
      )}
      <FormControl>
        <DateTimePicker
          defaultValue={field.value}
          onChange={field.onChange}
          label={fieldConfigItem?.label || label}
        />
      </FormControl>
      <AutoFormTooltip fieldConfigItem={fieldConfigItem} />

      <FormMessage />
    </FormItem>
  );
}
